var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data-Broker-Group-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Brokers-Creation-2",
    transform: "translate(-1317.000000, -511.000000)",
    fillRule: "nonzero",
    stroke: "#2C6BCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remove",
    transform: "translate(1299.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    transform: "translate(19.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84,-5.57975e-10 C11.9843902,-5.57975e-10 15.34,3.35560976 15.34,7.5 C15.34,11.6443902 11.9843902,15 7.84,15 C3.69560976,15 0.34,11.6443902 0.34,7.5 C0.34,3.35560976 3.69560976,-5.57975e-10 7.84,-5.57975e-10 Z",
    id: "Path-Copy",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22163973,4 C9.16247804,4.00722295 9.10750211,4.0342586 9.06570723,4.07673519 L4.51502396,8.62682481 C4.47992708,8.66177697 4.45534051,8.70587267 4.44405876,8.75410004 L4.00649306,10.679138 C3.98656675,10.7671414 4.0131832,10.8592132 4.0769942,10.9230158 C4.1408052,10.9868185 4.23288897,11.0134315 4.32090391,10.9935078 L6.24619298,10.5559992 C6.29450851,10.5449312 6.33866565,10.5203168 6.37348482,10.4850432 L10.9241681,5.93495361 C11.0252773,5.83268854 11.0252773,5.6681205 10.9241681,5.56585543 L9.43644471,4.07832613 C9.39883492,4.04005841 9.32723326,4.01394969 9.22163973,4 Z M9.25187154,4.63165521 L10.3688574,5.75008633 L6.18891165,9.92821407 L5.07319868,8.81264665 L9.25187154,4.63165521 Z M4.85171088,9.3319296 L5.66669688,10.1468093 L4.61399337,10.3873595 L4.85171088,9.3319296 Z",
    id: "np_edit_592766_000000",
    strokeWidth: 0.5,
    fill: "#2C6BCC"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilCircleIcon);
export default __webpack_public_path__ + "static/media/pencil-circle-icon.fd2e7028712177f8a41c578040710a40.svg";
export { ForwardRef as ReactComponent };